export const environment = {
  production: true,
  apiBaseUrl: 'https://csl-stories20190601091951-coreservicestaging.azurewebsites.net/',
  authBaseUrl: 'https://csl-stories20190601091951-authenticatedcslservicecore.azurewebsites.net/'
};
